import { useState } from 'react';
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Paper,
  Chip,
  Dialog,
} from '@mui/material';
import {
  Download as DownloadIcon,
  AttachFile as AttachFileIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import Badge from '../ui/Badge';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import DeletePermitBottomSheet from '../../Permit/ui/DeletePermitBottomSheet';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
import PerButton from '../../Permit/ui/PerButton';
import PinchZoom from '../../../Components/Ui/PinchZoom';

export default function M_NOT_BASIC_01({
  rowData1,
  Delete1,
  fileList,
  DownloadLogic2,
}) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [previewImage, setPreviewImage] = useState(null);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px: 2,
        gap: 4,
      }}
    >
      {/* 공지사항 상세 내용 */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* 뱃지 */}
        <Box
          sx={{
            display: 'flex',
            pb: 1,
          }}
        >
          <Badge data={rowData1} />
        </Box>

        <p
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            wordWrap: 'break-word',
          }}
        >
          {rowData1?.title}
        </p>
        <div
          style={{
            display: 'flex',
            paddingTop: '8px',
            gap: '8px',
          }}
        >
          <p style={{ fontSize: '14px', color: '#8B8888' }}>
            {rowData1?.createNm}
          </p>
          <p style={{ fontSize: '14px', color: '#8B8888' }}>
            {dayjs(rowData1?.createDate).format('YYYY-MM-DD HH:MM')}
          </p>
        </div>

        <hr
          style={{
            width: '100%',
            borderTop: '2px solid #F8EFEF',
          }}
        />
        <Paper
          elevation={0}
          sx={{
            background: '#fff',
            borderRadius: '12px',
            minHeight: '20vh',
            padding: 1,
          }}
        >
          <Box
            sx={{
              fontSize: '17px',
              color: '#333',
              lineHeight: 1.8,
              '& p': { marginBottom: '12px' },
            }}
            dangerouslySetInnerHTML={{
              __html: rowData1?.comment || '',
            }}
          />
        </Paper>
      </Box>

      {/* 첨부파일 목록 */}
      {fileList && fileList.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Stack sx={{ display: 'flex', alignItems: 'start' }}>
            <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
              첨부파일 ({fileList.length}개)
            </Typography>
          </Stack>

          {/* 이미지 파일 섹션 */}
          {fileList.some((f) =>
            /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
          ) && (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5,
                mb: 2,
              }}
            >
              {fileList
                .filter((f) =>
                  /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                )
                .map((item, idx) => (
                  <Box
                    key={idx}
                    role="button"
                    tabIndex={0}
                    aria-label={`${item.fileName} 크게 보기`}
                    onClick={() => setPreviewImage(item)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setPreviewImage(item);
                      }
                    }}
                    sx={{
                      position: 'relative',
                      width: 110,
                      height: 110,
                      border: '1px solid #ddd',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      backgroundColor: '#fefefe',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease',
                      cursor: 'zoom-in',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      },
                    }}
                  >
                    <img
                      src={`${Global.file.useUrl}files/${item.filePath}`}
                      alt={item.fileName}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        borderRadius: '50%',
                        padding: '4px',
                        '&:hover': {
                          backgroundColor: 'rgba(255,255,255,0.9)',
                        },
                      }}
                      size="small"
                      aria-label={`${item.fileName} 다운로드`}
                      onClick={(event) => {
                        event.stopPropagation();
                        DownloadLogic2(item);
                      }}
                    >
                      <DownloadIcon sx={{ fontSize: 18, color: '#333' }} />
                    </IconButton>
                  </Box>
                ))}
            </Box>
          )}

          {/* 일반 파일 섹션 */}
          {fileList.some(
            (f) => !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
          ) && (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
              }}
            >
              {fileList
                .filter(
                  (f) => !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
                )
                .map((item, idx) => (
                  <Chip
                    key={idx}
                    icon={<AttachFileIcon />}
                    label={item.fileName}
                    onClick={() => DownloadLogic2(item)}
                    color="primary"
                    variant="outlined"
                    sx={{
                      fontSize: '13px',
                      borderRadius: '12px',
                      '&:hover': {
                        backgroundColor: '#F3F4FF',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                      },
                    }}
                  />
                ))}
            </Box>
          )}
        </Box>
      )}

      {rowData1 &&
      userInfo &&
      rowData1.createId === Commons.DecryptoAES(userInfo.userid) ? (
        <PerButton
          cancelText="삭제"
          saveText="수정"
          cancelColor="#FF6161"
          onCancel={() =>
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'delete',
              })
            )
          }
          onClick={() => {
            dispatch(CommonActions.increaseStep());
            navigate(`/M_Notice/write/${rowData1?.chaebunNo}`);
          }}
        />
      ) : null}

      <Dialog
        fullScreen
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        PaperProps={{
          sx: {
            backgroundColor: '#262626',
            overflow: 'hidden',
          },
        }}
      >
        <IconButton
          aria-label="이미지 크게 보기 닫기"
          onClick={() => setPreviewImage(null)}
          sx={{
            position: 'absolute',
            top: 'max(56px, calc(env(safe-area-inset-top, 0px) + 12px))',
            right: 12,
            zIndex: 2,
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {previewImage && (
          <PinchZoom
            key={previewImage.filePath}
            initialScale={1}
            minScale={1}
            maxScale={5}
            doubleClickDisabled={false}
            wrapperStyle={{ width: '100%', height: '100%' }}
            componentWrapperStyle={{ width: '100%', height: '100%' }}
            componentContentStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            contents={
              <img
                src={`${Global.file.useUrl}files/${previewImage.filePath}`}
                alt={previewImage.fileName}
                draggable={false}
                style={{
                  display: 'block',
                  maxWidth: '100vw',
                  maxHeight: '100vh',
                  objectFit: 'contain',
                  userSelect: 'none',
                  WebkitUserDrag: 'none',
                }}
              />
            }
          />
        )}
      </Dialog>

      {bottomSheetState.bottom && bottomSheetState.type === 'delete' && (
        <DeletePermitBottomSheet
          Delete1={Delete1}
          title={'공지사항을 삭제하시겠습니까?'}
        />
      )}
    </Box>
  );
}
